import U from './../lib-utils'
import abstractLayer from './abstractLayer'
import libUnit from './../lib-units'
import events from './lib-events'

function gridLayer() {
  return (gridLayer.is(this) ? this.init : gridLayer.F).apply(
    this,
    Array.prototype.slice.call(arguments),
  )
}

var P = gridLayer.leu_extend(abstractLayer).prototype

P.canvas = null
P.context = null
P.canvas_antialiasing_supported = null
P.svg_filters_supported = null
P.step_down_cache = null

P.gridStepValue = null //
P.gridStepUnit = null // - XX mm шаг сетки в выбранных координатах
P.gridOffsetXPcu = 0 //5pcu
P.gridOffsetYPcu = 0 //10pcu
P.gridColor = '' //#ffffffff
P.gridStepPcuX = 0
P.gridStepPcuY = 0
P.showGrid = false
P.valid = false
P.snapCenterX = null // центральная точка для снапа
P.snapCenterY = null
P.snapStepX = null // шаг сетки для снапа
P.snapStepY = null
P.snapStepX2 = null // половина шага сетки для снапа по центру
P.snapStepY2 = null
P.snapMode = 0

P.on_snap = function (cx, cy) {
  if (this.valid && this.showGrid && this.snapMode > 0) {
    if (1 === this.snapMode) {
      return this.snapKnot(cx, cy)
    } else if (2 === this.snapMode) {
      return this.snapCenter(cx, cy)
    }
  }
  return null
}

P.snapKnot = function (cx, cy) {
  var dist = this.snapCenterX - cx
  var xk = Math.round(dist / this.snapStepX)
  var knotX = this.snapCenterX - xk * this.snapStepX
  dist = this.snapCenterY - cy
  var yk = Math.round(dist / this.snapStepY)
  var knotY = this.snapCenterY - yk * this.snapStepY
  return {
    x: knotX,
    y: knotY,
  }
}

P.snapCenter = function (cx, cy) {
  var scx = this.snapCenterX + this.snapStepX2
  var scy = this.snapCenterY + this.snapStepY2
  var dist = scx - cx
  var xk = Math.round(dist / this.snapStepX)
  var centerX = scx - xk * this.snapStepX
  dist = scy - cy
  var yk = Math.round(dist / this.snapStepY)
  var centerY = scy - yk * this.snapStepY
  return {
    x: centerX,
    y: centerY,
  }
}

P.on_init = function () {
  this.handle = document.createElement('div')
  this.handle.classList.add('lib-map-layer')
  this.handle.classList.add('lib-map-layer-grid-v-cnv')
  this.canvas = document.createElement('canvas')
  this.handle.appendChild(this.canvas)
  this.context = this.canvas.getContext('2d')
  this.canvas_antialiasing_supported = U.is_defined(
    this.context.imageSmoothingQuality,
  )
  this.svg_filters_supported = U.is_defined(this.context.filter)
  if (!this.super_antialiasing_supported && this.svg_filters_supported) {
    this.step_down_cache = {}
  }
  try {
    this.context.imageSmoothingEnabled = true
    this.context.imageSmoothingQuality = 'high'
  } catch (e) {
    //do nothing
  }

  this.layout.centralData.lem.on(
    events._RULLER_PRESET_CHANGED,
    this,
    this.onGridPreferencesChanged,
  )
  return this
}

P.onGridPreferencesChanged = function () {
  var cdr = U.safeObject(
    U.safeObject(
      U.safeObject(U.safeObject(this.layout.centralData).project).custom_data,
    ).ruller,
  )
  this.gridStepValue = U.floatMoreOr(cdr.gridStep, 0, null)
  var gsUnitId = U.NEString(cdr.gridUnit, 'mm')
  var gsuDomain = libUnit().domain('linear')
  if (gsuDomain) {
    this.gridStepUnit = gsuDomain.get(gsUnitId)
  } else {
    this.gridStepUnit = null
  }
  this.gridOffsetXPcu = U.FloatOr(cdr.gridOffsetX, 0)
  this.gridOffsetYPcu = U.FloatOr(cdr.gridOffsetY, 0)
  this.gridColor = U.NEString(cdr.gridColor, '#f0f0f0f0')
  var snap = U.NEString(cdr.snap, 'none')
  this.snapMode = 0
  if ('node' === snap) {
    this.snapMode = 1
  } else if ('center' === snap) {
    this.snapMode = 2
  }
  this.gridStepPcuX = null
  this.gridStepPcuY = null
  this.showGrid = U.any_bool(cdr.showGrid, false)
  if (null !== this.gridStepUnit) {
    if (null !== this.gridStepValue) {
      var pcuValx = U.floatMoreOr(cdr.xPcuVal, 0, null) // размер эталона в pcu
      var pcuValy = U.floatMoreOr(cdr.yPcuVal, 0, null) // размер эталона в pcu (y)
      if (null !== pcuValx && null !== pcuValy) {
        var kx = U.floatMoreOr(cdr.xK, 0, null) // количесво юнитов в эталоне
        var ky = U.floatMoreOr(cdr.yK, 0, null) // количесво юнитов в эталоне (y)
        if (null !== kx && null !== ky) {
          if (gsuDomain) {
            var xUnit = gsuDomain.get(U.NEString(cdr.xUnit, '&&'))
            var yUnit = gsuDomain.get(U.NEString(cdr.yUnit, '&&'))
            if (null !== xUnit && null !== yUnit) {
              var kxWithGridUnit = gsuDomain.convert(
                xUnit,
                this.gridStepUnit,
                kx,
              ) // количество юнитов шага сетки на pcuValx pcu
              var kyWithGridUnit = gsuDomain.convert(
                yUnit,
                this.gridStepUnit,
                ky,
              ) // количество юнитов шага сетки на pcuValy pcu
              // приводим к весу 1 pcu в выбранных юнитах
              var xPcuPerGridUnit = pcuValx / kxWithGridUnit
              var yPcuPerGridUnit = pcuValy / kyWithGridUnit
              this.gridStepPcuX = U.floatMoreOr(
                this.gridStepValue * xPcuPerGridUnit,
                0,
                null,
              )
              this.gridStepPcuY = U.floatMoreOr(
                this.gridStepValue * yPcuPerGridUnit,
                0,
                null,
              )
              // 100mm = 200pcu
              // st = 5cm
              // 10cm = 200pcu
              // 1cm = pcuVal / kWGU = 200 / 10 = 20pcu/cm
              // 5cm = 5cm*(20pcu/cm) = 100pcu
            }
          }
        }
      }
    }
  }
  this.valid = !!(null !== this.gridStepPcuX && null !== this.gridStepPcuY)

  this.draw()
}

/**
 * Вызывается менеджером
 * @returns {gridLayer}
 */
P.clear = function () {
  this.context.clearRect(
    0,
    0,
    this.get_layout_width(),
    this.get_layout_height(),
  )
  this.step_down_cache = null === this.step_down_cache ? null : {}
  return this
}

/**
 * Вызывается менеджером после ресайза
 * @returns {gridLayer}
 */
P.resize = function () {
  this.canvas.width = this.get_layout_width()
  this.canvas.height = this.get_layout_height()
  return this
}

/**
 *
 * @returns {background_layer}
 */
P.on_data_ready = function () {}

P.on_image_ready = function () {
  // load grid preferences
  this.onGridPreferencesChanged()
}

/**
 * @returns {background_layer}
 */
P.draw = function () {
  // основа для отрисовки - позиция и масштаб
  // и то и другое должен расчитать менеджер перед вызовом отрисовки
  this.context.clearRect(
    0,
    0,
    this.layout.calculation_result.viewport.w,
    this.layout.calculation_result.viewport.h,
  )
  /**
   * @note
   * Нужно запоминать формулу сетки для снапа
   * в пикселях канваса
   */
  if (this.valid && this.showGrid) {
    try {
      this.context.imageSmoothingEnabled = true
      this.context.msimageSmoothingEnabled = true
      this.context.mozimageSmoothingEnabled = true
      this.context.webkitimageSmoothingEnabled = true
      this.context.imageSmoothingQuality = 'high'
    } catch (e) {
      //do nothing
    }
    var crt = this.layout.calculator.translate_image_pcu(
      50,
      50,
      this.layout.calculation_result.viewport.w,
      this.layout.calculation_result.viewport.h,
      this.layout.scale,
      this.layout.center_x,
      this.layout.center_y,
    )
    var imageCenterViewportX = crt.viewport.px.x
    var imageCenterViewportY = crt.viewport.px.y
    var stepCPX =
      this.gridStepPcuX *
      this.layout.calculation_result.image.pc1x *
      this.layout.scale // шаг в пикселях канваса
    var offsetCPX =
      this.gridOffsetXPcu *
      this.layout.calculation_result.image.pc1x *
      this.layout.scale // оффсет в пикселях канваса
    var stepCPY =
      this.gridStepPcuY *
      this.layout.calculation_result.image.pc1y *
      this.layout.scale // шаг в пикселях канваса (y)
    var offsetCPY =
      this.gridOffsetYPcu *
      this.layout.calculation_result.image.pc1y *
      this.layout.scale // оффсет в пикселях канваса (y)

    /*
         * P.snapCenterX = null; // центральная точка для снапа
         P.snapCenterY = null;
         P.snapStepX = null; // шаг сетки для снапа
         P.snapStepY = null;
         P.snapStepX2 = null; // половина шага сетки для снапа по центру
         P.snapStepY2 = null;
         */
    this.snapCenterX = imageCenterViewportX + offsetCPX
    this.snapCenterY = imageCenterViewportY + offsetCPY
    this.snapStepX = stepCPX
    this.snapStepX2 = stepCPX / 2.0
    this.snapStepY = stepCPY
    this.snapStepY2 = stepCPY / 2.0

    if (stepCPX >= 16 && stepCPY >= 16) {
      this.context.beginPath()
      //vertical
      var cpos = this.snapCenterX
      while (cpos < this.layout.calculation_result.viewport.w) {
        this.context.moveTo(cpos - 0.5, 0)
        this.context.lineTo(
          cpos - 0.5,
          this.layout.calculation_result.viewport.h,
        )
        cpos += stepCPX
      }
      cpos = this.snapCenterX - stepCPX
      while (cpos > 0) {
        this.context.moveTo(cpos - 0.5, 0)
        this.context.lineTo(
          cpos - 0.5,
          this.layout.calculation_result.viewport.h,
        )
        cpos -= stepCPX
      }
      //horizontal
      cpos = this.snapCenterY
      while (cpos < this.layout.calculation_result.viewport.h) {
        this.context.moveTo(0, cpos - 0.5)
        this.context.lineTo(
          this.layout.calculation_result.viewport.w,
          cpos - 0.5,
        )
        cpos += stepCPY
      }
      cpos = this.snapCenterY - stepCPY
      while (cpos > 0) {
        this.context.moveTo(0, cpos - 0.5)
        this.context.lineTo(
          this.layout.calculation_result.viewport.w,
          cpos - 0.5,
        )
        cpos -= stepCPY
      }
      this.context.strokeStyle = this.gridColor
      this.context.lineWidth = 1
      this.context.stroke()
    }
  }
}

export default gridLayer
